import { useEffect, useRef } from "react";

type SetTimeoutFn = {
    (cb: TimerHandler, timeout?: number, ...args: unknown[]): number;
};

type HookResult = SetTimeoutFn;

function useSetTimeout(): HookResult {
    const timestampRef = useRef<number>(0);

    useEffect(
        () => () => {
            clearTimeout(timestampRef.current);
        },
        [],
    );

    return (cb: TimerHandler, timeout?: number, ...args: unknown[]): number => {
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        timestampRef.current = setTimeout(cb, timeout, ...args);

        return timestampRef.current;
    };
}

export default useSetTimeout;
